/* eslint-disable ember/use-ember-data-rfc-395-imports */
import type DS from 'ember-data';
import type { ModelSchema } from 'ember-data';
import { type ModelRegistry } from 'ember-data/model';
import BadgeLogAdapter from 'garaje/adapters/badge-log';
import urlBuilder from 'garaje/utils/url-builder';

interface MacAddressMappingQuery {
  source?: string;
  query?: string;
  sort?: string;
  page?: {
    offset?: number;
    limit?: number;
  };
  [key: string]: unknown;
}

export default class MacAddressMappingAdapter extends BadgeLogAdapter {
  get headers(): Record<string, string> {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }

  urlForQuery(_query: MacAddressMappingQuery): string {
    return urlBuilder.macAddressMappings.list();
  }

  /**
   * Override `query` so we can control how the query params
   * are serialized into the URL (filter[source], filter[query], etc.)
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  query<K extends keyof ModelRegistry>(_store: DS.Store, _type: ModelSchema<K>, query: MacAddressMappingQuery) {
    const baseUrl = this.urlForQuery(query);
    const queryString = this.buildQueryString(query);
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    return this.ajax(url, 'GET');
  }

  buildQueryString(params: MacAddressMappingQuery): string {
    const entries: [string, string][] = [];

    if (params.source) {
      entries.push(['filter[source]', params.source]);
    }

    if (params.query) {
      entries.push(['filter[query]', params.query]);
    }

    if (params.sort) {
      entries.push(['sort', params.sort]);
    }

    if (params.page?.limit != null) {
      entries.push(['page[limit]', String(params.page.limit)]);
    }

    if (params.page?.offset != null) {
      entries.push(['page[offset]', String(params.page.offset)]);
    }

    return entries.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
  }
}
